import React from "react";
import { Link } from "react-router-dom";
import { formatSeasonDisplayName } from "../../utils/seasonName";

const UpcomigMatches = ({
  playerProfileData,
  userId,
  isSeasonOpenForRegistration = false,
  hasPaidForSeason = false,
  registeredSeasonName = null,
  isSchedulePosted = false,
}) => {
  const accessToken = localStorage.getItem("accessToken");
  const isVisitor = !accessToken;

  let showBanner = false;
  let bannerImage, buttonText, linkPath, headingContent;

  // ================= BANNER LOGIC =================
  if (isVisitor) {
    showBanner = true;
    bannerImage = "/images/get-profile.png";
    buttonText = "SIGN UP TODAY!";
    linkPath = "/carter/signup";

    headingContent = (
      <h4>
        Get your own player Profile Page & communicate with other Open Play
        Tennis members For Free
      </h4>
    );
  } else {
    if (!isSeasonOpenForRegistration) {
      showBanner = false;
    } else if (hasPaidForSeason && isSchedulePosted) {
      // Paid and schedule already posted / matches in play — no waiting banner.
      showBanner = false;
    } else {
      showBanner = true;

      if (hasPaidForSeason) {
        bannerImage = "/images/Picture4.jpeg";
        buttonText = "Schedules Coming Soon";
        //linkPath = `/carter/schedule?userId=${userId}`;
        linkPath = "#";

        const seasonLabel = registeredSeasonName
          ? ` ${formatSeasonDisplayName(registeredSeasonName)}`
          : "";

        headingContent = (
          <>
            <h5 className="head_1">You're on the</h5>
            <h3 className="head_2">SERVICE LINE!</h3>
            <span className="head_3">{seasonLabel}</span>
          </>
        );
      } else {
        bannerImage = "/images/Picture2.jpeg";
        buttonText = "REGISTER NOW";

        const firstName =
          playerProfileData?.firstName || playerProfileData?.first_name || "";
        const lastName =
          playerProfileData?.lastName || playerProfileData?.last_name || "";

        linkPath = `/carter/signupregistrationsuccess?first_name=${encodeURIComponent(
          firstName,
        )}&last_name=${encodeURIComponent(lastName)}`;

        headingContent = (
          <h4>
            Registration is now open for the next season of Open Play Tennis!
          </h4>
        );
      }
    }
  }

  // ================= DATE FORMAT =================
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "N/A";

    return new Intl.DateTimeFormat("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    }).format(date);
  };

  // ================= RENDER =================
  return (
    <div className="col-sm-12 col-lg-4">
      {/* HEADER */}
      <div className="profile-caption heading-golfer largeYHeightHeader">
        <h4>Upcoming Matches</h4>
        <img src="/images/match.png" alt="tee" />
      </div>

      <div className="clear">&nbsp;</div>

      {/* MATCH INFO */}
      {playerProfileData?.playBy ? (
        <div className="flu-box shadow" style={{ marginBottom: "20px" }}>
          <p>{formatDate(playerProfileData.playBy)}</p>

          <p>
            {playerProfileData?.upcomingOpponentId ? (
              <Link
                to={`/carter/profile?userId=${playerProfileData.upcomingOpponentId}`}
                style={{
                  color: "#F70A0A",
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                {playerProfileData?.upcomingMatchesName}
              </Link>
            ) : playerProfileData?.upcomingMatchesName &&
              String(playerProfileData.upcomingMatchesName).toLowerCase() !==
                "unknown player" &&
              String(playerProfileData.upcomingMatchesName).toUpperCase() !==
                "TBD" &&
              String(playerProfileData.upcomingMatchesName).toUpperCase() !==
                "BYE" ? (
              <span style={{ color: "#F70A0A", fontWeight: "bold" }}>
                {playerProfileData.upcomingMatchesName}
              </span>
            ) : (
              <span style={{ color: "#F70A0A", fontWeight: "bold" }}>TBD</span>
            )}
            {playerProfileData?.upcomingOpponentId ||
            (playerProfileData?.upcomingMatchesName &&
              String(playerProfileData.upcomingMatchesName).toLowerCase() !==
                "unknown player" &&
              String(playerProfileData.upcomingMatchesName).toUpperCase() !==
                "TBD" &&
              String(playerProfileData.upcomingMatchesName).toUpperCase() !==
                "BYE")
              ? ` at ${playerProfileData?.homeCourt || "N/A"}`
              : null}
          </p>
        </div>
      ) : (
        <div className="flu-box shadow" style={{ marginBottom: "20px" }}>
          No scheduled matches
        </div>
      )}

      {/* VIEW SCHEDULE */}
      {userId && (
        <div
          className="flu-box shadow viewschedule"
          style={{ marginBottom: "20px" }}
        >
          <Link
            to={`/carter/schedule?userId=${userId}`}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <h4 style={{ cursor: "pointer" }}>
              View {playerProfileData?.firstName}‘s schedule
            </h4>
          </Link>
        </div>
      )}

      {/* ================= BANNER ================= */}
      {showBanner && (
        <div className="regbanner">
          <div>
            <div className="heading-golfer">{headingContent}</div>

            <img className="tee-off-img" src={bannerImage} alt="banner" />

            <div className="subsection">
              <div className="buttonwrapper">
                <Link to={linkPath} className="squarebutton">
                  <span>{buttonText}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ================= EQUIPMENT ================= */}
      <div className="profile-caption heading-golfer">
        <h4>Equipment</h4>
        <img src="/images/equpment.png" alt="Equipment" />
      </div>

      <div className="subsection equpment">
        <div className="flu-box shadow">
          <p>Racquet : {playerProfileData?.Racquet || ""}</p>
          <p>Strings : {playerProfileData?.Strings || ""}</p>
          <p>Shoes : {playerProfileData?.shoes || ""}</p>
          <p>Favorite Player : {playerProfileData?.favoritePlayer || ""}</p>
        </div>
      </div>
    </div>
  );
};

export default UpcomigMatches;
